// https://www.npmjs.com/package/web-push#using-vapid-key-for-applicationserverkey
function urlBase64ToUint8Array(base64String) {
	// eslint-disable-next-line no-mixed-operators
	const padding = '='.repeat((4 - base64String.length % 4) % 4)
	const base64 = (base64String + padding)
		.replace(/-/g, '+')
		.replace(/_/g, '/')

	const rawData = window.atob(base64)
	const outputArray = new Uint8Array(rawData.length)

	for (let i = 0; i < rawData.length; i += 1) {
		outputArray[i] = rawData.charCodeAt(i)
	}

	return outputArray
}

export default class WebPushHelper {
	/**
	 * @constructor
	 * @param {string} key - VAPID public key
	 * @param {string} file - Worker filename
	 * @param {string} scope - Worker scope
	 */
	constructor(key, file, scope) {
		this._key = key
		this._file = file
		this._scope = scope
		this._registration = null
	}

	static get isSupported() {
		return 'Notification' in window && 'serviceWorker' in navigator
	}

	async init() {
		if (!this._registration) {
			this._registration = await navigator.serviceWorker.register(
				this._file,
				{ scope: this._scope },
			)
		}
	}

	async _getSubscription() {
		await this.init()
		if (!this._registration) { return null }

		return this._registration.pushManager.getSubscription()
	}

	async isSubscribed() {
		const subscription = await this._getSubscription()
		return !!subscription
	}

	async getPermissionState() {
		await this.init()
		return this._registration.pushManager.permissionState({
			userVisibleOnly: true,
		})
	}

	async subscribe() {
		const subscription = await this._getSubscription()
		if (subscription) { return subscription }

		return this._registration.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: urlBase64ToUint8Array(this._key),
		})
	}

	async unsubscribe() {
		const subscription = await this._getSubscription()
		if (subscription) {
			subscription.unsubscribe()
		}
	}
}
